import {
    ACTION_FAIL_MESSAGE,
    ActionType,
    AUTO_MODE,
    ConditionInfos,
    DATE_MONTH_YEAR_FORMAT,
    DaysMap,
    DeviceTypeDict,
    EVENT_ENABLED_DELETE_MESSAGE,
    EVENT_ENABLED_EDIT_MESSAGE,
    EVENT_ENABLED_MODIFY_MESSAGE,
    EVENT_VARIABLE_TIMER_FORMAT,
    EventNameMaxCharacter,
    FETCH_EVENT_VARIABLES_FAIL_MESSAGE,
    FETCH_EVENTS_FAIL_MESSAGE,
    FETCH_GATEWAY_FAIL_MESSAGE,
    HttpStatus,
    LDSUTypeDict,
    MANUAL_MODE,
    MonthsMap,
    NEW_ACTION_MESSAGE,
    PWM_MODE,
    TypeOption,
    variableType
} from "constant";
import {
    capitalize,
    cloneDeep,
    find,
    get,
    isEmpty,
    maxBy,
    set,
    sortBy,
    startCase,
} from "lodash";
import { KeyboardEvent, MouseEvent, useEffect, useState } from "react";
import {
    Breadcrumb,
    Button,
    Col,
    Container,
    Form,
    FormControl,
    Modal,
    Row,
} from "react-bootstrap";
import { Link, useHistory, useParams } from "react-router-dom";
import {
    getAllRegistry,
    getRegistryGroups,
    getRegistryInfo,
} from "service/gatewayService";
import LocalStorageService from "service/localStorageService";

import dltWhiteIcon from "assets/svg/delete-white.svg";
import drag from "assets/svg/drag.svg";
import editIcon from "assets/svg/edit.svg";
import evaluateIconBackdrop from "assets/svg/evaluate-backdrop.svg";
import evaluateIcon from "assets/svg/evaluate.svg";
import ActionActuator from "assets/svg/event-action-actuator.svg";
import DelayIcon from "assets/svg/event-action-delay.svg";
import ActionEmail from "assets/svg/event-action-email.svg";
import ActionNotification from "assets/svg/event-action-notification.svg";
import ActionSMS from "assets/svg/event-action-sms.svg";
import eventEditIcon from "assets/svg/event-edit.svg";
import gatewayStatusIcon from "assets/svg/gateway-status.svg";
import dateIcon from "assets/svg/on-date.svg";
import recurrenceIcon from "assets/svg/recurrence.svg";
import sensorStatusIcon from "assets/svg/sensor-status.svg";
import sensorValueIcon from "assets/svg/sensor-value.svg";
import HoverAuthorizeTooltip from "components/authorize/AuthorizeTooltip";
import ContentWrapper from "components/content-wrapper/ContentWrapper";
import LDSUSelectModal from "components/modals/LDSUSelectModal";
import DefaultModal from "components/modals/ModalTemplate";
import SensorActuatorSelectModal from "components/modals/SensorActuatorSelectModal";
import SetDelayModal, {
    defaultDelayValue,
} from "components/modals/SetDelayModal";
import { WalletAlertComponent } from "hooks/wallet";
import moment from "moment";
import EventService from "service/eventService";
import OrganisationService from "service/organisationService";
import { canAccess } from "utils/authorize-action";
import getEventInfo, {
    convertBEOperator,
    isValid,
    showWarning,
} from "utils/eventFunctions";
import {
    convertSecondsToTimeString,
    formatValueWithUnit,
    getAccuracyFromOBJ,
    getPrimaryUnit,
    handleAccuracyException,
    isFourWiredMotorControllerApp,
    isHttpSuccess,
    orgId,
} from "utils/functions";
import GridStackElement from "utils/gridstack";

import { faker } from "@faker-js/faker";
import "assets/css/event.css";
import SelectEventVariableModal from "components/events/SelectEventVariableModal";
import { Group, Variable } from "generated/models";
import { useCheckIfBasicPlan } from "hooks/useCheckIfBasicPlan";
import ActionItem from "pages/events/components/actions/ActionItem";
import DelayWarningAction from "pages/events/components/actions/DelayWarningAction";
import EventVariableService from "service/eventVariableService";
import { MemberDto, MemberStatus, ResponseDto } from "types";
import { getAPIError, showErrorAlert, showSuccessAlert } from "utils/alert";
import { isStandaloneGroup } from "utils/gatewayFunctions";

const spacePlaceHolder = "　";
const SensorValueText: Record<string, string> = {
    ">": "Is above {formattedValue}",
    "<": "Is below {formattedValue}",
    ">=": "Rises above {formattedValue}",
    "<=": "Falls below {formattedValue}",
    "==": "Is equal to {value}",
    "===": "Changes to {value}",
    in: "Is within a range of {formattedMin} to {formattedMax}",
    "not in": "Is outside a range of {formattedMin} to {formattedMax}",
    "in=": "Enters into a range of {formattedMin} to {formattedMax}",
    "not in=": "Exits from a range of {formattedMin} to {formattedMax}",
};

export const getDisplayedActuatorMode = (configMode: any) => {
    let configMode_ = "";

    if (configMode === PWM_MODE) {
        configMode_ = configMode;
    } else {
        configMode_ = capitalize(configMode);
    }

    return configMode_;
};
const EventDetails = () => {
    const metricCLSList = LocalStorageService.getItem("metricInfo").cls;
    const [selectCondition, setSelectCondition] = useState(false);
    const [selectGateway, setSelectGateway] = useState(false);
    const [selectModalVisible, setSelectModalVisible] = useState(false);
    const [selectedCondition, setSelectedCondition] = useState("");
    const [selectedOperator, setSelectedOperator] = useState("");
    const [selectedSlotIndex, setSelectedSlotIndex] = useState(0);
    const [unitType, setUnitType] = useState(DeviceTypeDict.sensor.label);
    const [radioBtnSelected, setRadioBtnSelected] = useState(false);
    const [isShowDeleteModal, setIsShowDeleteModal] = useState(false);
    const [isShowEventVariables, setIsShowEventVariables] = useState(false);
    const [eventVariables, setEventVariables] = useState([]);

    const [orgSelectionList, setOrgSelectionList] = useState<Array<MemberDto>>(
        []
    );

    const [toDelete, setToDelete] = useState({
        type: "",
        id: "",
    });

    const [selectedSensorDetails] = useState({
        name: "",
        gatewayName: "",
        bus: "",
        ldsuUUID: "",
        type: "",
        gatewayId: "",
        unit: "",
        said: "",
        min: "",
        max: "",
    });

    const handleConditionsClose = () => setSelectCondition(false);

    const [selectAction, setSelectAction] = useState(false);
    const params: any = useParams();
    const [eventDetail, setEventDetail]: any = useState({});

    const [gatewayGroupList, setGatewayGroupList] = useState<Group[]>([]);
    const [initialGatewayGroupList, setInitialGatewayGroupList] = useState<
        Group[]
    >([]);
    const [allGateways, setAllGateways] = useState([]);

    const [selectedGateway, setSelectedGateway] = useState("");
    const [conditionList, setConditionList] = useState([]);
    const [actionList, setActionList] = useState<any[]>([]);
    const [isNameEditing, setIsNameEditing] = useState(false);
    const [editableName, setEditableName] = useState("");
    const [slotCount, setSlotCount] = useState(0);
    const history = useHistory();

    const [modalShow, setModalShow] = useState(false);
    const [modalType, setModalType] = useState("");
    const [modalContent, setModalContent] = useState("");
    const [showGuardWarning, setShowGuardWarning] = useState(false);

    const [isPageLoading, setIsPageLoading] = useState(true);
    const [eventActive, setEventActive] = useState(false);
    const [editDelayObj, setEditDelayObj] = useState<{
        delay: number;
        action?: any;
    }>({ delay: defaultDelayValue });
    const [isForbiddenResource, setIsForbiddenResource] = useState(false);
    const [isLoaded, setIsLoaded] = useState(false);
    const [eventVariableSelected, setEventVariableSelected] = useState("");
    const [goToActionDetail, setGoToActionDetail] = useState(false);
    const { IS_BASIC_PLAN } = useCheckIfBasicPlan();
    const [warningPosition, setWarningPosition] = useState<number | null>(null);

    const CONDITION_SENSOR_VALUE = "sensor-value";
    const CONDITION_LDSU_STATUS = "ldsu-status";
    const CONDITION_SENSOR_STATUS = "sensor-status";
    const CONDITION_GATEWAY_STATUS = "gateway-status";
    const CONDITION_RECURRENCE = "recurrence";
    const CONDITION_ONDATE = "on-date";
    const CONDITION_VARIABLE = "event-variable";
    const ACTION_SMS = "sms";
    const ACTION_EMAIL = "email";
    const ACTION_NOTIF = "notification";
    const ACTION_ACTUATOR = "actuator";
    const ACTION = "action";
    const CONDITION = "condition";
    const EVENT = "event";

    useEffect(() => {
        const fetchEventVariables = async () => {
            const fetchResp = await EventVariableService.readEventVariables();

            if (fetchResp.status === HttpStatus.FORBIDDEN) {
                setIsForbiddenResource(true);
            } else if (!isHttpSuccess(fetchResp.status)) {
                showErrorAlert(
                    getAPIError(fetchResp, FETCH_EVENT_VARIABLES_FAIL_MESSAGE)
                );
            } else {
                setEventVariables(fetchResp.data);
            }
        };

        fetchEventVariables();
    }, []);

    useEffect(() => {
        const fetchAllGateways = async () => {
            const allGatewaysRes = await getAllRegistry();
            const { status, data: gateways = [] } = allGatewaysRes;
            if (status === HttpStatus.FORBIDDEN) {
                setIsPageLoading(false);
                setIsForbiddenResource(true);
            } else if (isHttpSuccess(status)) {
                const onBoardedGateways = gateways.filter(
                    ({ info }: { info: any }) => info
                );
                setAllGateways(onBoardedGateways);
                setIsLoaded(true);
            } else {
                showErrorAlert(
                    getAPIError(allGatewaysRes, FETCH_GATEWAY_FAIL_MESSAGE)
                );
            }
        };
        fetchAllGateways();
    }, []);

    useEffect(() => {
        const fetch = async () => {
            const response: any = await getRegistryGroups();

            if (isHttpSuccess(response.status)) {
                const { data: groups } = response;
                const groupsWithOnboardedGateways: Group[] = groups.map(
                    (group: Group) => {
                        const updatedGateways = group.gateways.filter(
                            (gateway: any) => gateway.info
                        );
                        return {
                            ...group,
                            gateways: updatedGateways,
                        };
                    }
                );
                setGatewayGroupList(groupsWithOnboardedGateways);
                setInitialGatewayGroupList(groupsWithOnboardedGateways);
            }
        };
        fetch();
    }, []);

    const handleActionsClose = () => setSelectAction(false);

    const sortAndUpdateAction = async (actions: any[] = []) => {
        const sortedActions = sortBy(
            actions.filter((action) => action.type_ !== "WARNING"),
            "order"
        );
        const { data }: ResponseDto<Variable[]> =
            await EventVariableService.readEventVariables();
        const eventVariablesMap = new Map(
            data?.map((item: Variable) => [item.uuid, item]) ?? []
        );

        let seenTimers = new Set();
        const actionWithWarning: any[] = [];
        let totalDelay = 0;
        let seenActuators = new Set();
        for (const action of sortedActions) {
            // check delay -> clear timerId
            if (action.type_ === ActionType.DELAY) {
                totalDelay += action.resource.seconds;
                if (totalDelay >= 5) {
                    seenTimers.clear();
                    seenActuators.clear();
                }
            }

            // check Timer variable -> add warning if need
            if (action.type_ === ActionType.VARIABLE) {
                const variable: Variable | undefined = eventVariablesMap.get(
                    action.resource.variable
                );
                if (variable?.type_ === TypeOption.Timer) {
                    if (seenTimers.has(variable.uuid)) {
                        actionWithWarning.push({
                            uuid: faker.datatype.uuid(),
                            type_: "WARNING",
                            order: action.order - 0.5,
                        });
                    }
                    seenTimers.add(variable.uuid);
                    totalDelay = 0;
                }
            }

            if (action.type_ === ActionType.ACTUATOR) {
                const actuatorKey = `${action.resource?.gateway_id}|${action.resource?.device_id}|${action.resource?.said}`;

                if (seenActuators.has(actuatorKey)) {
                    actionWithWarning.push({
                        uuid: faker.datatype.uuid(),
                        type_: "WARNING",
                        order: action.order - 0.5,
                    });
                }
                seenActuators.add(actuatorKey);
                totalDelay = 0;
            }

            if (action.resource?.gateway_id) {
                const res = await getRegistryInfo(action.resource?.gateway_id);
                const device = get(res, "data.devices", []).find(
                    (device: any) => device.UID === action.resource?.device_id
                );
                const app = device?.APP?.[action.resource?.said];

                if (isHttpSuccess(res.status) && device && app) {
                    const isFourWired = isFourWiredMotorControllerApp(
                        device.OBJ,
                        app.APPID
                    );

                    action.fourWireApp = isFourWired;
                }
            }

            actionWithWarning.push(action);
        }
        setActionList(actionWithWarning);
    };

    const updateEventState = async ({ data }: any) => {
        const {
            conditions = [],
            actions = [],
            name = "",
            activate = false,
        } = data;

        setEventDetail(data);
        setEditableName(name);

        // for conditions
        const max = Math.max(...conditions.map((c: any) => c.slot));
        setSlotCount(max + 1);
        setConditionList(conditions);

        // for actions
        await sortAndUpdateAction(actions);

        // De-active edit event when event is active
        setEventActive(activate);
    };

    const fetchEvent = async () => {
        const eventResp = await EventService.readOneEvent(params.eventId);

        if (eventResp.status === HttpStatus.FORBIDDEN) {
            setIsForbiddenResource(true);
        } else if (!isHttpSuccess(eventResp.status)) {
            showErrorAlert(getAPIError(eventResp, FETCH_EVENTS_FAIL_MESSAGE));
        } else {
            await updateEventState(eventResp);
        }

        setIsPageLoading(false);
    };

    useEffect(() => {
        if (!canAccess("event:read")) {
            setIsPageLoading(false);
            setIsForbiddenResource(true);
        } else {
            fetchEvent();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [params.eventId, window.authorizationConfig]);

    useEffect(() => {
        const fetch = async () => {
            const { status, data = [] } =
                await OrganisationService.getOrgMembers(orgId());
            if (isHttpSuccess(status)) {
                // filter userInformation out for selection purpose.
                const orgList = data
                    .toCamelCase<MemberDto>()
                    .filter((curr) => curr.status !== MemberStatus.Pending);
                setOrgSelectionList(orgList);
            }
        };

        fetch();
    }, []);

    const showError = () => {
        showErrorAlert({
            message: EVENT_ENABLED_MODIFY_MESSAGE,
        });
    };

    const addFirstConditionGroup = () => {
        setSelectCondition(true);
        setUnitType(DeviceTypeDict.sensor.label);
    };

    const addNewConditionGroup = () => {
        if (eventActive) {
            return showError();
        }
        setSelectCondition(true);
        setUnitType(DeviceTypeDict.sensor.label);
        setSelectedOperator("OR");
    };

    const addToSameConditionGroup = (index: number) => {
        if (eventActive) {
            return showError();
        }
        setSelectCondition(true);
        setUnitType(DeviceTypeDict.sensor.label);
        setSelectedOperator("AND");
        setSelectedSlotIndex(index);
    };

    const addNewAction = () => {
        if (eventActive) {
            return showError();
        }
        setSelectAction(true);
    };

    const showLDSUSelection = () => {
        setUnitType(LDSUTypeDict.LDSU.label);
        setSelectedCondition(CONDITION_LDSU_STATUS);
        handleConditionsClose();
        setSelectModalVisible(true);
    };

    const showSensorSelection = () => {
        setUnitType(DeviceTypeDict.sensor.label);
        setSelectedCondition(CONDITION_SENSOR_VALUE);
        setSelectCondition(false);
        setSelectModalVisible(true);
    };

    const showGatewaySelection = () => {
        setSelectedCondition(CONDITION_GATEWAY_STATUS);
        handleConditionsClose();
        setSelectGateway(true);
    };

    const showActuatorSelection = () => {
        setSelectModalVisible(true);
        setUnitType(DeviceTypeDict.actuator.label);
        handleActionsClose();
    };

    const showDelayModal = () => {
        setSelectModalVisible(true);
        setUnitType("delay");
        handleActionsClose();
    };

    const editDelayModal = (action: any) => {
        setSelectModalVisible(true);
        setUnitType("delay");
        setSelectAction(false);
        setEditDelayObj({
            delay: Number(action.resource?.seconds),
            action,
        });
    };

    const handleCreateDelayAction = async (data: number) => {
        const latestAction: any = maxBy(actionList, "order");
        const max = latestAction?.order ?? 0;
        let previousActionIndex = 0;
        if (warningPosition) {
            previousActionIndex = actionList.findIndex(
                (action) => action.order === warningPosition
            );
        }

        if (
            typeof warningPosition === "number" &&
            !Number.isInteger(warningPosition) &&
            Number(data) < 5
        ) {
            showErrorAlert({
                message: "Delay timer must be at least 5 seconds.",
            });
            setWarningPosition(null);
            return;
        }

        // Calculate the order for the new delay action
        const newOrder = warningPosition
            ? (actionList[previousActionIndex].order + warningPosition) / 2
            : max + 1;

        const response = await EventService.createAction(params.eventId, {
            type_: "DELAY",
            resource: {
                seconds: Number(data),
            },
            order: newOrder,
        });

        if (isHttpSuccess(response.status)) {
            // Create a new action object with the predefined order
            const newAction = {
                ...response.data,
                order: newOrder,
            };

            // Build orders object based on the updated action list
            const updatedActionList = [...actionList, newAction];
            const orders: Record<string, number> = {};
            sortBy(
                updatedActionList.filter(
                    (action) => action.type_ !== "WARNING"
                ),
                "order"
            ).forEach((action, index) => {
                orders[action.uuid] = index;
            });

            // Call sort service to persist the order
            if (orders && Object.keys(orders).length > 0) {
                await EventService.sortOrderAction(params.eventId, orders);
            }

            // Fetch event to update the action list with correct orders from backend
            await fetchEvent();

            showSuccessAlert({
                message: NEW_ACTION_MESSAGE,
            });
        } else {
            showErrorAlert(getAPIError(response, ACTION_FAIL_MESSAGE));
        }
        setWarningPosition(null);
    };

    const handleEditDelayAction = async (data: any) => {
        if (!editDelayObj.action) {
            // Create event delay action
            handleCreateDelayAction(data);
            setEditDelayObj({ delay: defaultDelayValue });
            return;
        }

        if (Number(editDelayObj.delay) === Number(data)) {
            return;
        }

        // Patch event delay action
        const response = await EventService.updateAction(
            params.eventId,
            editDelayObj.action.uuid,
            {
                type_: "DELAY",
                resource: {
                    seconds: Number(data),
                },
            }
        );

        if (!isHttpSuccess(response.status)) {
            setModalShow(true);
            setModalType("err");
            setModalContent(response.data.description);
            return;
        }

        const actionListCloned = [...actionList];
        set(
            find(actionListCloned, {
                uuid: editDelayObj.action.uuid,
            }),
            "resource.seconds",
            Number(data)
        );
        await sortAndUpdateAction(actionListCloned);

        setEditDelayObj({ delay: defaultDelayValue });
    };

    const proceedToRecurrencePage = () => {
        handleConditionsClose();
        showCondition(CONDITION_RECURRENCE);
    };

    const proceedToOnDatePage = () => {
        handleConditionsClose();
        showCondition(CONDITION_ONDATE);
    };

    const showDeleteConfirmation = (type: string, uuid: string) => {
        if (eventActive) {
            return showErrorAlert({
                message: EVENT_ENABLED_MODIFY_MESSAGE,
            });
        }

        setToDelete({
            type: type,
            id: uuid,
        });
        showDeleteModal(type);
    };

    const showDeleteEventConfirmation = () => {
        if (eventActive) {
            return showErrorAlert({
                message: EVENT_ENABLED_DELETE_MESSAGE,
            });
        }

        setToDelete({
            ...toDelete,
            type: EVENT,
        });
        showDeleteModal(EVENT);
    };

    const closeGatewaySelection = () => {
        searchGateways("");
        setSelectGateway(false);
        setRadioBtnSelected(false);
    };

    const searchGateways = (query: string) => {
        if (query !== "") {
            const filteredGatewayGroupList = cloneDeep(initialGatewayGroupList);

            let group: any;
            for (group of filteredGatewayGroupList) {
                const filteredGateways = [];
                for (const gateway of group.gateways) {
                    if (
                        gateway.name.toLowerCase().includes(query.toLowerCase())
                    ) {
                        filteredGateways.push(gateway);
                    }
                }
                group.gateways = filteredGateways;
            }
            setGatewayGroupList(
                filteredGatewayGroupList.filter(
                    (g: any) => g.gateways.length > 0
                )
            );
        } else {
            setGatewayGroupList(initialGatewayGroupList);
        }
    };

    const showDeleteModal = (type: string) => {
        setModalShow(true);
        setModalType("dlt");
        setModalContent(`Do you want to delete this ${type}?`);
    };

    const showAction = (actionType: string, config: any = {}) => {
        history.push(`/event-details/${params.eventId}/action/${actionType}`, {
            ...config,
        });
    };

    const showCondition = (condition?: string, config = {}) => {
        if (
            condition === CONDITION_ONDATE ||
            condition === CONDITION_RECURRENCE
        ) {
            history.push(
                `/event-details/${params.eventId}/condition/${condition}`,
                {
                    selectedOperator,
                    slotCount,
                    selectedSlotIndex,
                }
            );
        } else {
            history.push(
                `/event-details/${params.eventId}/condition/${selectedCondition}`,
                {
                    selectedSensorDetails,
                    selectedOperator,
                    slotCount,
                    selectedSlotIndex,
                    selectedGateway,
                    // selectedGatewayName,
                    ...config,
                }
            );
        }
    };

    const editName = (e: any) => {
        if (isNameEditing) {
            setEditableName(e.target.value);
        }
    };

    const handleNameEditUpdate = async () => {
        // validation for blank names and special chars
        const editableNameTrim = String(editableName).trim();
        setEditableName(editableNameTrim);

        if (!isNameEditing && eventActive) {
            return showErrorAlert({
                message: EVENT_ENABLED_EDIT_MESSAGE,
            });
        }

        setIsNameEditing(!isNameEditing);

        if (isNameEditing) {
            if (editableNameTrim === eventDetail.name) {
                setIsNameEditing(false);
                return;
            }

            if (
                !editableNameTrim ||
                editableNameTrim.length > EventNameMaxCharacter
            ) {
                setIsNameEditing(true);

                showErrorAlert({
                    title: "Invalid Event Name",
                    message: `Event name must be 1-${EventNameMaxCharacter} characters long and not contain leading or trailing spaces or non-English characters.`,
                });

                return;
            }

            const response = await EventService.updateEvent(params.eventId, {
                name: editableNameTrim,
            });

            if (!isHttpSuccess(response.status)) {
                showErrorAlert(getAPIError(response, ACTION_FAIL_MESSAGE));
            } else {
                showSuccessAlert({
                    message: "Event name has been updated successfully.",
                });
                setEventDetail({ ...eventDetail, name: editableNameTrim });
            }
        }
    };

    const toggleEventStatus = async (event_id: string, active: boolean) => {
        // call get Event API

        if (!isValid(eventDetail, allGateways)) {
            return showWarning();
        }

        const eventUpdateResp = await EventService.updateEvent(event_id, {
            activate: !active,
        });

        if (!isHttpSuccess(eventUpdateResp.status)) {
            showErrorAlert(getAPIError(eventUpdateResp, ACTION_FAIL_MESSAGE));
        } else {
            showSuccessAlert({
                title: "success",
                message: `Event has been ${
                    active ? "disabled" : "enabled"
                } successfully.`,
            });
            setEventActive(!eventActive);
        }
    };

    const deleteCondition = async () => {
        const response = await EventService.deleteCondition(
            params.eventId,
            toDelete.id
        );

        if (!isHttpSuccess(response.status)) {
            showErrorAlert(getAPIError(response, ACTION_FAIL_MESSAGE));
        } else {
            setModalShow(false);
            showSuccessAlert({
                message: "Condition has been deleted successfully.",
            });

            fetchEvent().then(() => {
                const element = document.getElementById("gs-" + toDelete.id);
                const elementGrid = element?.parentNode as any;
                elementGrid?.gridstack?.removeWidget(element);
            });
        }
    };

    const deleteAction = async () => {
        const response = await EventService.deleteAction(
            params.eventId,
            toDelete.id
        );

        if (!isHttpSuccess(response.status)) {
            showErrorAlert(getAPIError(response, ACTION_FAIL_MESSAGE));
        } else {
            setModalShow(false);
            showSuccessAlert({
                message: "Action has been deleted successfully.",
            });

            const clone = [...actionList];
            const filtered = clone.filter((action: any) => {
                return action.uuid !== toDelete.id;
            });
            await sortAndUpdateAction(filtered);
        }
    };

    const deleteEvent = async () => {
        const response = await EventService.deleteEvent(params.eventId);
        if (isHttpSuccess(response.status)) {
            showSuccessAlert({
                message: `Event has been deleted successfully.`,
            });
            setModalShow(false);
            history.push(`/events`);
        } else {
            showErrorAlert(getAPIError(response, ACTION_FAIL_MESSAGE));
        }
    };

    const checkModify = (
        e?: MouseEvent<HTMLAnchorElement, globalThis.MouseEvent>
    ) => {
        if (eventActive) {
            if (e) {
                e.preventDefault();
                e.stopPropagation();
            }

            showError();
            return false;
        }

        return true;
    };

    const renderEditCondition = (
        conditionType: string,
        id: string,
        conditionPayload?: any
    ) => (
        <HoverAuthorizeTooltip permission="event:update" className="event-edit">
            <Link
                to={{
                    pathname: `/event-details/${params.eventId}/condition/${conditionType}/${id}`,
                    state: conditionPayload
                        ? { conditionPayload: conditionPayload }
                        : {},
                }}
                onClick={checkModify}
            >
                <img
                    width={19}
                    height={19}
                    src={eventEditIcon}
                    alt="Edit condition or event"
                />
            </Link>
        </HoverAuthorizeTooltip>
    );

    const handleAddDelay = (position: number) => {
        setEditDelayObj({
            delay: Number.isInteger(position) ? defaultDelayValue : 5,
        });
        setWarningPosition(position);
        setSelectModalVisible(true);
        setUnitType("delay");
    };

    const renderActions = () => {
        const actions = actionList.map((action: any) => {
            if (action.type_ === "WARNING") {
                return (
                    <DelayWarningAction
                        key={action.uuid}
                        action={action}
                        handleAddDelay={handleAddDelay}
                    />
                );
            }

            const jsonList = LocalStorageService.getItem("listOfJSON");
            const {
                resource: { recipients, gateway_id, device_id, said, variable },
                uuid,
            } = action;
            let sensor: any = {};

            const eventVariableAction: any = eventVariables.find(
                (item: any) => item.uuid === variable
            );

            const deviceOBJ: any = allGateways.reduce((acc: any, g: any) => {
                if (g.gateway_id === gateway_id && g.info) {
                    const deviceList = g.info.devices;

                    const selectedSensor = deviceList.find((d: any) => {
                        return d.UID === device_id;
                    });

                    if (selectedSensor) {
                        acc += selectedSensor.OBJ;
                        sensor = selectedSensor;
                    }
                }
                return acc;
            }, "");

            const getClassAndUnitFromOBJandSAID = (
                obj: string,
                said: string
            ) => {
                const selectedSensor = jsonList.find((j: any) => {
                    return j.OBJ === obj;
                });
                const unit: any = selectedSensor?.SNS[said]?.UNIT;
                const cls: any = selectedSensor?.SNS[said]?.CLS;
                const type: string =
                    sensor.APP?.[said]?.NAME ?? metricCLSList?.[cls]?.name;

                return {
                    unit,
                    type,
                };
            };

            const getActionAndConfigMode = allGateways.reduce(
                (acc: any, g: any) => {
                    if (g.gateway_id === gateway_id && g.configs) {
                        const gatewayConfigList = g.configs;

                        const selectedSensor = gatewayConfigList.find(
                            (d: any) => {
                                return d.UID === device_id;
                            }
                        );

                        if (selectedSensor) {
                            acc.actionMode = selectedSensor.CMDS[said].auto
                                ? AUTO_MODE
                                : MANUAL_MODE;
                            acc.configMode = selectedSensor.CMDS[said].mode;
                        }
                    }
                    return acc;
                },
                {}
            );
            const { actionMode = "MANUAL", configMode } =
                getActionAndConfigMode;

            const sensorName: any = allGateways.reduce((acc: any, g: any) => {
                if (g.gateway_id === gateway_id && g.configs.length > 0) {
                    const sensorList = g.configs;
                    const selectedSensor = sensorList.find((s: any) => {
                        return s.UID === device_id;
                    });

                    if (selectedSensor) {
                        acc += selectedSensor.sensor_names?.[said];
                    }
                }
                return acc;
            }, "");

            let recipientListBody: MemberDto[] = [];

            if (!isEmpty(orgSelectionList) && !isEmpty(recipients)) {
                for (const savedRecipient of recipients || []) {
                    const temp = orgSelectionList.find((member) => {
                        return (
                            member?.username?.toLowerCase() ===
                            savedRecipient?.toLowerCase()
                        );
                    });
                    recipientListBody.push(temp!);
                }
            }

            return (
                <div
                    className="grid-stack-item"
                    id={`gs-${uuid}`}
                    gs-w="12"
                    key={`action-${uuid}`}
                    gs-no-resize="true"
                >
                    <div className="action-item">
                        <ActionItem
                            actionId={uuid}
                            eventId={params.eventId}
                            showDeleteConfirm={() => {
                                showDeleteConfirmation(ACTION, uuid);
                            }}
                            actuatorName={sensorName}
                            actuatorType={startCase(
                                getClassAndUnitFromOBJandSAID(deviceOBJ, said)
                                    .type || spacePlaceHolder
                            )}
                            actuatorMode={getDisplayedActuatorMode(configMode)}
                            actuatorControl={capitalize(actionMode)}
                            action={action}
                            eventActive={eventActive}
                            editDelayAction={() => {
                                editDelayModal(action);
                            }}
                            eventVariableAction={eventVariableAction}
                        />
                    </div>
                </div>
            );
        });
        return (
            <GridStackElement
                id="actions-list-gridstack"
                itemCount={Number(actionList.length)}
                options={{
                    disableDrag: eventActive,
                }}
                items={actionList}
                onChange={({ event, data }) => {
                    if (event.type === "dragstop" || event.type === "dropped") {
                        const orders: any = {};
                        sortBy(data, "y")
                            .filter((item) => !item.isWarning)
                            .forEach(
                                (item, index) =>
                                    (orders[
                                        String(item.id).replace("gs-", "")
                                    ] = index)
                            );

                        orders &&
                            EventService.sortOrderAction(
                                params.eventId,
                                orders
                            ).then(async () => {
                                await fetchEvent();
                            });
                    }
                }}
            >
                {actions}
            </GridStackElement>
        );
    };

    const getCommonValue = (variableItem: any, threshold: string) => {
        if (variableItem?.type_ === TypeOption.Timer) {
            return convertSecondsToTimeString(
                +threshold,
                EVENT_VARIABLE_TIMER_FORMAT
            );
        }

        if (variableItem?.type_ === TypeOption.Boolean) {
            return threshold;
        }

        if (variableItem?.type_ === TypeOption.Float) {
            return Number(threshold).toFixed(2);
        }

        if (variableItem?.type_ === TypeOption.Counter) {
            if (+threshold === +variableItem?.attributes?.terminal) {
                return "Terminal Value";
            } else if (+threshold === +variableItem?.initial) {
                return "Initial Value";
            }
        }

        return Number(threshold);
    };

    const renderConditions = (conditions: any) => {
        const list = sortBy(conditions, "order").map((condition: any) => {
            const { uuid, type_, resource } = condition;

            const renderConditionIcon = () => {
                switch (type_) {
                    case "LDSU":
                        return <img src={sensorStatusIcon} alt="" />;
                    case "GATEWAY":
                        return <img src={gatewayStatusIcon} alt="" />;
                    case "SENSOR":
                        return <img src={sensorValueIcon} alt="" />;
                    case "DATETIME":
                        if (resource.date2?.repeat)
                            return <img src={recurrenceIcon} alt="" />;
                        return <img src={dateIcon} alt="" />;
                    case variableType:
                        return <img src={evaluateIcon} alt="" />;
                }
            };

            const renderConditionContent = () => {
                const jsonList = LocalStorageService.getItem("listOfJSON");

                const {
                    type_,
                    resource: {
                        device: {
                            for_ = null,
                            gateway_id = "",
                            device_id = "",
                            said = "",
                            operator = null,
                            edge_trigger = false,
                            status = null,
                            thresholds = null,
                            threshold = "",
                            variable = "",
                            trigger_once = true,
                        } = {},
                        date1: {
                            day = "",
                            time_: {
                                ranges: ranges1 = null,
                                points: points1 = null,
                                schedule: schedule1 = "",
                                interval: interval1 = "",
                            } = {},
                        } = {},
                        date2: {
                            repeat = "",
                            [repeat]: {
                                ranges: ranges2 = null,
                                points: points2 = null,
                                interval: interval2 = "",
                            } = {},
                            weekly: { weekdays: weeklyWeekdays = {} } = {},
                            monthly: {
                                weekdays: monthlyWeekdays = {},
                                days: monthlyDays = {},
                            } = {},
                            yearly: { months = null } = {},
                        } = {},
                    },
                } = condition;

                const variableItem: any = eventVariables.find(
                    ({ uuid }) => uuid === variable
                );

                const gwName: string = allGateways.reduce(
                    (acc: any, g: any) => {
                        if (g.gateway_id === gateway_id) {
                            acc += g.name;
                        }
                        return acc;
                    },
                    ""
                );

                if (type_ === "LDSU") {
                    const ldsuName = allGateways.reduce(
                        // eslint-disable-next-line array-callback-return
                        (acc: any, curr: any) => {
                            if (curr.configs) {
                                const ldsu: any = curr.configs.find(
                                    (l: any) => {
                                        return l.UID === device_id;
                                    }
                                );
                                if (ldsu) acc += ldsu?.name;
                                return acc;
                            }
                        },
                        ""
                    );

                    if (!ldsuName) {
                        return (
                            <span className="warning-message">
                                <i className="material-icons outlined">
                                    error_outline
                                </i>
                                <span>This LDSU is not found</span>
                            </span>
                        );
                    }

                    return (
                        <>
                            {ldsuName}
                            {renderEditCondition(CONDITION_LDSU_STATUS, uuid)}
                            <p>LDSU UUID: {device_id}</p>
                            <h6>
                                {status === "online" ? "Comes" : "Goes"}{" "}
                                {status} for {for_} sec(s)
                            </h6>
                        </>
                    );
                } else if (type_ === "GATEWAY") {
                    if (!gwName) {
                        return (
                            <span className="warning-message">
                                <i className="material-icons outlined">
                                    error_outline
                                </i>
                                <span>This Gateway is not found</span>
                            </span>
                        );
                    }

                    return (
                        <>
                            {gwName || spacePlaceHolder}
                            {renderEditCondition(
                                CONDITION_GATEWAY_STATUS,
                                uuid
                            )}
                            <p>UUID: {gateway_id}</p>
                            <h6>
                                {status === "online" ? "Comes" : "Goes"}{" "}
                                {status} for {for_} sec(s)
                            </h6>
                        </>
                    );
                } else if (type_ === "SENSOR") {
                    let sensor: any = {};
                    const deviceOBJ: any = allGateways.reduce(
                        (acc: any, g: any) => {
                            if (g.gateway_id === gateway_id && g.info) {
                                const deviceList = g.info.devices;

                                const selectedSensor = deviceList.find(
                                    (d: any) => {
                                        return d.UID === device_id;
                                    }
                                );

                                if (selectedSensor) {
                                    acc += selectedSensor.OBJ;
                                    sensor = selectedSensor;
                                }
                            }
                            return acc;
                        },
                        ""
                    );

                    const sensorName: any = allGateways.reduce(
                        (acc: any, g: any) => {
                            if (g.configs.length > 0) {
                                const sensorList = g.configs;
                                const selectedSensor = sensorList.find(
                                    (s: any) => {
                                        return s.UID === device_id;
                                    }
                                );

                                if (selectedSensor)
                                    acc += selectedSensor.sensor_names?.[said];
                            }
                            return acc;
                        },
                        ""
                    );
                    const accuracy = getAccuracyFromOBJ({
                        object: deviceOBJ,
                        jsonList,
                        said,
                        isChart: false,
                    });

                    const accuracyException = handleAccuracyException(accuracy);

                    const getClassAndUnitFromOBJandSAID = (
                        obj: string,
                        said: string
                    ) => {
                        const selectedSensor = jsonList.find((j: any) => {
                            return j.OBJ === obj;
                        });

                        const unit: any = sensor.APP?.length
                            ? getPrimaryUnit(sensor.APP[said])
                            : selectedSensor?.SNS[said]?.UNIT;
                        const cls: any = selectedSensor?.SNS[said]?.CLS;
                        const type: string = sensor.APP
                            ? sensor.APP[said].NAME
                            : metricCLSList?.[cls]?.name;

                        return { unit, type };
                    };

                    let message: any;
                    let unit: any = getClassAndUnitFromOBJandSAID(
                        deviceOBJ,
                        said
                    ).unit;

                    if (unit === "C") {
                        unit = "°C";
                    } else if (unit === "na") {
                        unit = "";
                    }

                    const value = Number(thresholds[0]).toFixed(
                        accuracyException
                    );
                    message = SensorValueText[
                        convertBEOperator(operator, edge_trigger)
                    ].fill({
                        value,
                        formattedValue: formatValueWithUnit(value, unit),
                    });

                    if (thresholds[1]) {
                        const min = Number(thresholds[0]).toFixed(
                            accuracyException
                        );
                        const max = Number(thresholds[1]).toFixed(
                            accuracyException
                        );
                        message = SensorValueText[
                            convertBEOperator(operator, edge_trigger)
                        ].fill({
                            min,
                            max,
                            formattedMin: formatValueWithUnit(min, unit),
                            formattedMax: formatValueWithUnit(max, unit),
                        });
                    }

                    if (!sensorName) {
                        return (
                            <span className="warning-message">
                                <i className="material-icons outlined">
                                    error_outline
                                </i>
                                <span>This Sensor is not found</span>
                            </span>
                        );
                    }

                    return (
                        <>
                            {sensorName}
                            {renderEditCondition(CONDITION_SENSOR_VALUE, uuid)}
                            <p>LDSU UUID: {device_id}</p>
                            <p>
                                {getClassAndUnitFromOBJandSAID(deviceOBJ, said)
                                    .type || spacePlaceHolder}
                            </p>
                            <h6>
                                {message} and remains for {for_} sec(s)
                            </h6>
                        </>
                    );
                } else if (type_ === variableType) {
                    const triggerOnce = trigger_once ? "when" : "is";
                    let operatorConst = `${triggerOnce}-${operator}`;

                    return (
                        <>
                            {renderEditCondition(
                                CONDITION_VARIABLE,
                                variableItem?.uuid,
                                {
                                    operator,
                                    variable,
                                    threshold,
                                    uuid,
                                    slot: condition.slot,
                                    trigger_once,
                                }
                            )}
                            <h6>{variableItem?.name || ""}</h6>
                            <p>
                                Event Variable -{" "}
                                {variableItem?.type_
                                    ?.toLowerCase()
                                    ?.capitalize() || ""}
                            </p>
                            <h6>
                                {(variableItem?.type_ as TypeOption) !==
                                TypeOption.Boolean
                                    ? ConditionInfos[operatorConst].label
                                    : triggerOnce.capitalize()}{" "}
                                {getCommonValue(variableItem, threshold)}
                            </h6>
                        </>
                    );
                } else if (type_ === "DATETIME" && !repeat) {
                    const renderTimeStatement = () => {
                        return getEventInfo(
                            schedule1,
                            ranges1,
                            points1,
                            interval1
                        );
                    };

                    return (
                        <>
                            <h6>
                                On {moment(day).format(DATE_MONTH_YEAR_FORMAT)}
                            </h6>
                            {renderEditCondition(CONDITION_ONDATE, uuid)}
                            {renderTimeStatement()}
                        </>
                    );
                } else if (type_ === `DATETIME` && repeat) {
                    const renderTimeStatement = () => {
                        const renderDailyTimeStatement = () => {
                            return getEventInfo(
                                resource.date2[repeat].schedule,
                                ranges2,
                                points2,
                                interval2
                            );
                        };

                        const renderWeeklyTimeStatement = () => {
                            let days = "";
                            let numOfDays = 0;
                            for (let d = 1; d < 8; d++) {
                                if (
                                    Object.keys(weeklyWeekdays).includes(`${d}`)
                                ) {
                                    numOfDays += 1;
                                    if (numOfDays > 1) {
                                        days += `, ${DaysMap[d]}`;
                                    } else {
                                        days += ` ${DaysMap[d]}`;
                                    }
                                }
                            }
                            return days;
                        };

                        const renderMonthlyTimeStatement = () => {
                            const formattedDays: any = [];
                            const formattedWeekdays: any = [];
                            let days = "On ";

                            if (!isEmpty(monthlyDays)) {
                                formattedDays.push(
                                    ...Object.keys(monthlyDays).map(
                                        (d: any) => {
                                            switch (d) {
                                                case "-1":
                                                    return `Last day`;
                                                case "1":
                                                case "21":
                                                case "31":
                                                    return `${d}st`;
                                                case "2":
                                                case "22":
                                                    return `${d}nd`;
                                                case "3":
                                                case "23":
                                                    return `${d}rd`;
                                                default:
                                                    return `${d}th`;
                                            }
                                        }
                                    )
                                );
                            }

                            if (!isEmpty(monthlyWeekdays)) {
                                formattedWeekdays.push(
                                    ...Object.keys(monthlyWeekdays).map(
                                        (d: any) => {
                                            if (Number(d) > 0) {
                                                return `First ${DaysMap[d]}`;
                                            } else {
                                                d = Number(d) * -1;
                                                return `Last ${DaysMap[d]}`;
                                            }
                                        }
                                    )
                                );
                            }
                            const combined: any =
                                formattedDays.concat(formattedWeekdays);
                            days += combined.toString().replaceAll(",", ", ");

                            return days;
                        };

                        const renderYearlyTimeStatement = () => {
                            let days = "On ";
                            const formattedDays: any = [];
                            const formattedWeekdays: any = [];
                            for (const m in months) {
                                if (!isEmpty(months[m].days)) {
                                    formattedDays.push(
                                        ...Object.keys(months[m].days).map(
                                            (d: any) => {
                                                switch (d) {
                                                    case "-1":
                                                        return `Last day of ${MonthsMap[m]}`;
                                                    case "1":
                                                    case "21":
                                                    case "31":
                                                        return `${MonthsMap[m]} ${d}st`;
                                                    case "2":
                                                    case "22":
                                                        return `${MonthsMap[m]} ${d}nd`;
                                                    case "3":
                                                    case "23":
                                                        return `${MonthsMap[m]} ${d}rd`;
                                                    default:
                                                        return `${MonthsMap[m]} ${d}th`;
                                                }
                                            }
                                        )
                                    );
                                }

                                if (!isEmpty(months[m].weekdays)) {
                                    formattedWeekdays.push(
                                        ...Object.keys(months[m].weekdays).map(
                                            (d: any) => {
                                                if (Number(d) > 0) {
                                                    return `First ${DaysMap[d]} of ${MonthsMap[m]}`;
                                                } else {
                                                    d = Number(d) * -1;
                                                    return `Last ${DaysMap[d]} of ${MonthsMap[m]}`;
                                                }
                                            }
                                        )
                                    );
                                }
                            }

                            const combined: any =
                                formattedDays.concat(formattedWeekdays);
                            days += combined.toString().replaceAll(",", ", ");

                            return days;
                        };
                        switch (repeat) {
                            case "daily":
                                return renderDailyTimeStatement();
                            case "weekly":
                                return renderWeeklyTimeStatement();
                            case "monthly":
                                return renderMonthlyTimeStatement();
                            case "yearly":
                                return renderYearlyTimeStatement();
                        }
                    };

                    return (
                        <>
                            <h6>{capitalize(repeat)}</h6>
                            {renderEditCondition(CONDITION_RECURRENCE, uuid)}

                            <p>Recurrence</p>
                            {renderTimeStatement()}
                        </>
                    );
                }
            };

            return (
                <div
                    className="grid-stack-item"
                    id={`gs-${uuid}`}
                    key={`condition-${uuid}`}
                    gs-w="12"
                    gs-no-resize="true"
                >
                    <div className="condition-item">
                        <div className="condition-box">
                            {renderConditionIcon()}

                            <div className="condition-texts">
                                {renderConditionContent()}
                            </div>
                            <HoverAuthorizeTooltip
                                permission="event:update"
                                className="drag-action"
                            >
                                <img
                                    className="grid-stack-item-content"
                                    width={24}
                                    height={24}
                                    src={drag}
                                    alt="drag"
                                />
                            </HoverAuthorizeTooltip>
                        </div>
                        <HoverAuthorizeTooltip
                            permission="event:delete"
                            className="remove-action"
                        >
                            <span
                                className="material-icons"
                                aria-label="delete-condition"
                                onClick={() => {
                                    showDeleteConfirmation(CONDITION, uuid);
                                }}
                                onKeyDown={() => {
                                    showDeleteConfirmation(CONDITION, uuid);
                                }}
                            >
                                close
                            </span>
                        </HoverAuthorizeTooltip>
                        <div className="and-section">
                            <div className="and-btn">AND</div>
                        </div>
                    </div>
                </div>
            );
        });
        return list;
    };

    const renderSlots = () => {
        const slots: any = [];
        let condition: any;
        for (let i = 0; i < slotCount; i++) {
            slots[i] = [];
            for (condition of conditionList) {
                if (condition.slot === i) {
                    slots[i].push(condition);
                }
            }
        }

        const list = slots.map((slot: any, index: any) => {
            // eslint-disable-next-line array-callback-return
            if (!slot.length) return;

            return (
                <div key={`condition-slot-wrapper-${slot[0].uuid}`}>
                    <GridStackElement
                        id={`condition-slot-${index}`}
                        key={`condition-slot-${slot[0].uuid}`}
                        itemCount={slot?.length}
                        gap={0}
                        options={{
                            acceptWidgets: ".conditions-list .grid-stack-item",
                            disableDrag: eventActive,
                        }}
                        onChange={(res) => {
                            const orders: any = {};
                            const slots: any = {};
                            const itemSlots: { [key: string]: any[] } = {};

                            document
                                .querySelectorAll(
                                    ".conditions-list .grid-stack-item"
                                )
                                .forEach((item) => {
                                    const slot = get(
                                        item,
                                        "parentNode.id"
                                    ).replace("condition-slot-", "");
                                    const id = item.id.replace("gs-", "");
                                    const order = item.getAttribute("gs-y");
                                    itemSlots[slot] = [
                                        ...(itemSlots[slot] || []),
                                        { id, order },
                                    ];
                                });

                            for (const slot in Object.values(itemSlots)) {
                                sortBy(
                                    Object.values(itemSlots)[slot],
                                    "order"
                                ).forEach((item, index) => {
                                    orders[item.id] = index;
                                    slots[item.id] = Number(slot);
                                });
                            }

                            document
                                .querySelectorAll(`[id^="condition-slot-"]`)
                                .forEach((ele: any) => {
                                    if (!ele.innerHTML) {
                                        try {
                                            ele.nextElementSibling.remove();
                                            ele.nextElementSibling.remove();
                                            ele.parentNode.removeChild(ele);
                                        } catch {}
                                    }
                                });

                            EventService.sortOrderCondition(
                                params.eventId,
                                orders,
                                slots
                            );
                        }}
                    >
                        {renderConditions(slot)}
                    </GridStackElement>
                    <div className="add-condition-item">
                        {eventDetail?.passive_slots?.includes(
                            slot[0]?.slot
                        ) && (
                            <div className="condition-guard-warn">
                                <span className="material-icons">
                                    error_outline
                                </span>
                                <p>
                                    Add one more condition here.{" "}
                                    <button
                                        className="link-button"
                                        onClick={() => {
                                            setShowGuardWarning(true);
                                        }}
                                    >
                                        Learn more
                                    </button>
                                </p>
                            </div>
                        )}
                        <HoverAuthorizeTooltip permission="event:create">
                            <Button
                                variant="primary add-item"
                                onClick={() => {
                                    addToSameConditionGroup(index);
                                }}
                            >
                                +
                            </Button>
                        </HoverAuthorizeTooltip>
                    </div>

                    <div className="or-section">
                        <div className="or-btn">OR</div>
                    </div>
                </div>
            );
        });
        return list;
    };

    const renderGateways = () => {
        // eslint-disable-next-line array-callback-return
        const groups = gatewayGroupList.map((group: any) => {
            if (group.gateways.length) {
                return (
                    <div key={group.uuid}>
                        {isStandaloneGroup(group) ? (
                            <h4>Standalone</h4>
                        ) : (
                            <h4>{group.name}</h4>
                        )}

                        {group.gateways.map((gateway: any) => {
                            return (
                                <div
                                    className="modal-option"
                                    key={gateway.uuid}
                                >
                                    <Form.Check
                                        name="selected-gateway"
                                        value={gateway.gateway_id}
                                        onChange={(e) => {
                                            setSelectedGateway(e.target.value);
                                            setRadioBtnSelected(true);
                                        }}
                                        id={gateway.gateway_id}
                                        custom
                                        type="radio"
                                        label={
                                            <div>
                                                <h4>{gateway.name}</h4>{" "}
                                                <p>
                                                    UUID: {gateway.gateway_id}
                                                </p>
                                            </div>
                                        }
                                        className="float-left"
                                    />
                                </div>
                            );
                        })}
                    </div>
                );
            }
        });
        return groups;
    };

    const handleSelectEventVariable = () => {
        setIsShowEventVariables(false);
        if (!eventVariableSelected) {
            return;
        }
        history.push(
            `/event-details/${params.eventId}/${
                goToActionDetail ? "action" : "condition"
            }/event-variable/${eventVariableSelected}`,
            {
                selectedOperator,
                slotCount,
                selectedSlotIndex,
            }
        );
        setEventVariableSelected("");
    };

    return (
        <ContentWrapper
            isLoading={isPageLoading}
            isForbiddenResource={isForbiddenResource}
        >
            <div className="page-content">
                <Container fluid>
                    <Row>
                        <Col xs="6">
                            <h5 className="page-title overflow-text">
                                {eventDetail.name}
                            </h5>
                        </Col>
                        <Col xs="6" className="text-right">
                            <HoverAuthorizeTooltip permission="event:delete">
                                <Button
                                    variant="danger"
                                    onClick={showDeleteEventConfirmation}
                                >
                                    <span>
                                        <img
                                            className="mr-2 ml-2"
                                            src={dltWhiteIcon}
                                            alt="dlt"
                                        />
                                    </span>
                                    Delete
                                </Button>
                            </HoverAuthorizeTooltip>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs="12">
                            <Breadcrumb className="w-100">
                                <Breadcrumb.Item href="/events">
                                    Events
                                </Breadcrumb.Item>
                                <Breadcrumb.Item active>
                                    Event Details
                                </Breadcrumb.Item>
                            </Breadcrumb>
                        </Col>
                    </Row>
                    <Row>
                        <Col md="3">
                            <div className="form-box enable-event-box">
                                <span>Enable this event</span>
                                <HoverAuthorizeTooltip permission="event:update">
                                    <div>
                                        <Form.Check
                                            type="switch"
                                            id={`switch_${params.eventId}`}
                                            label=""
                                            checked={eventActive}
                                            disabled={
                                                !canAccess("event:update")
                                            }
                                            onChange={() => {
                                                toggleEventStatus(
                                                    params.eventId,
                                                    eventActive
                                                );
                                            }}
                                        />
                                    </div>
                                </HoverAuthorizeTooltip>
                            </div>
                        </Col>
                        <Col>
                            <Form>
                                <div className="form-box mb-2 mt-3 mt-md-0">
                                    <Form.Row className="align-items-center">
                                        <Col md="1">
                                            <Form.Label>Event Name</Form.Label>
                                        </Col>
                                        <Col md="9" xs="12">
                                            <Form.Group className="mb-0">
                                                <Form.Control
                                                    type="text"
                                                    required
                                                    aria-label="name"
                                                    name="eventName"
                                                    value={editableName}
                                                    onChange={editName}
                                                    disabled={!isNameEditing}
                                                    onKeyPress={(
                                                        e: KeyboardEvent<HTMLInputElement>
                                                    ) => {
                                                        if (e.key === "Enter") {
                                                            e.preventDefault();
                                                            handleNameEditUpdate();
                                                        }
                                                    }}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col md="2" xs="12">
                                            <HoverAuthorizeTooltip
                                                permission="event:update"
                                                className="w-100 mt-2 mt-md-0"
                                            >
                                                <Button
                                                    type="button"
                                                    variant={"primary"}
                                                    className="w-100"
                                                    onClick={() => {
                                                        handleNameEditUpdate();
                                                    }}
                                                >
                                                    {isNameEditing ? (
                                                        "Update"
                                                    ) : (
                                                        <>
                                                            <span>
                                                                <img
                                                                    className="mr-2 ml-1"
                                                                    src={
                                                                        editIcon
                                                                    }
                                                                    alt="Edit Event Name"
                                                                />
                                                            </span>
                                                            Edit
                                                        </>
                                                    )}
                                                </Button>
                                            </HoverAuthorizeTooltip>
                                        </Col>
                                    </Form.Row>
                                </div>
                            </Form>
                        </Col>
                    </Row>

                    <Row className="my-3">
                        <Col sm={12}>
                            {!IS_BASIC_PLAN && (
                                <WalletAlertComponent showWarningWhen="LowBalance" />
                            )}
                        </Col>
                    </Row>

                    <Row className="mb-2">
                        <Col xs="12">
                            <h4>Conditions and Actions</h4>
                        </Col>
                    </Row>

                    <Row className="mb-2">
                        <Col xs="12">
                            <div className="form-box condition-note-box">
                                <span>Note: </span>
                                <span className="note-text">
                                    Event conditions or actions with a
                                    duration/delay shorter than the report rate
                                    interval will not function as expected.
                                </span>
                            </div>
                        </Col>
                    </Row>

                    {isLoaded && (
                        <Row className="conditions-actions">
                            <Col lg="6">
                                <div className="when-do-title">When</div>

                                {/* If No Conditions to list  */}
                                {!conditionList.length ? (
                                    <div className="conditions-list-empty">
                                        <p>
                                            Add conditions to trigger this event
                                        </p>
                                        <HoverAuthorizeTooltip permission="event:create">
                                            <Button
                                                variant="outline-primary"
                                                onClick={addFirstConditionGroup}
                                                className="add-condition-action-btn"
                                            >
                                                + ADD CONDITION
                                            </Button>
                                        </HoverAuthorizeTooltip>
                                    </div>
                                ) : (
                                    ""
                                )}

                                {/* If actions to list  */}
                                <div className="conditions-list">
                                    {/* //////////////Condition Groups//////////////// */}
                                    <div className="condition-group">
                                        {conditionList.length
                                            ? renderSlots()
                                            : ""}
                                    </div>

                                    {/* ////////////////New Condition Group////////////////// */}
                                    {conditionList.length ? (
                                        <HoverAuthorizeTooltip permission="event:create">
                                            <Button
                                                variant="primary add-item"
                                                onClick={addNewConditionGroup}
                                            >
                                                +
                                            </Button>
                                        </HoverAuthorizeTooltip>
                                    ) : (
                                        ""
                                    )}
                                </div>
                                <div className="divider"></div>
                            </Col>
                            <Col lg="6">
                                <div className="arrow-circle">
                                    <i className="material-icons right">
                                        keyboard_arrow_right
                                    </i>
                                </div>

                                <div className="when-do-title">Do</div>
                                {/* If No actions to list  */}
                                {!actionList.length ? (
                                    <div className="actions-list-empty">
                                        <p>
                                            Add the actions this event will run.
                                        </p>
                                        <HoverAuthorizeTooltip permission="event:create">
                                            <Button
                                                variant="outline-primary"
                                                onClick={() =>
                                                    setSelectAction(true)
                                                }
                                                className="add-condition-action-btn"
                                            >
                                                + ADD ACTION
                                            </Button>
                                        </HoverAuthorizeTooltip>
                                    </div>
                                ) : (
                                    ""
                                )}
                                {/* If actions to list  */}
                                <div className="actions-list">
                                    {renderActions()}

                                    {actionList.length ? (
                                        <HoverAuthorizeTooltip permission="event:create">
                                            <Button
                                                variant="primary add-item"
                                                onClick={addNewAction}
                                            >
                                                +
                                            </Button>
                                        </HoverAuthorizeTooltip>
                                    ) : (
                                        ""
                                    )}
                                </div>
                            </Col>
                        </Row>
                    )}
                </Container>
            </div>
            {/* Select Condition Modal */}
            <Modal
                show={selectCondition}
                onHide={handleConditionsClose}
                animation={false}
                centered
            >
                <Modal.Header>
                    <Modal.Title>Add Condition</Modal.Title>
                    <Button
                        variant=""
                        className="close-button"
                        onClick={handleConditionsClose}
                    >
                        <span className="material-icons">close</span>
                    </Button>
                </Modal.Header>

                <Modal.Body>
                    <Form className="condition-options-list">
                        <div className="scroll-list float-left">
                            <div
                                className="modal-option"
                                onClick={showLDSUSelection}
                                onKeyDown={showLDSUSelection}
                            >
                                <img
                                    src={sensorStatusIcon}
                                    alt="sensor-status"
                                />
                                <div className="float-left">
                                    <h4>LDSU Status</h4>
                                    <p>E.g. “When LDSU goes offline”</p>
                                </div>
                                <i className="material-icons right">
                                    keyboard_arrow_right
                                </i>
                            </div>

                            <div
                                className="modal-option"
                                onClick={showSensorSelection}
                                onKeyDown={showSensorSelection}
                            >
                                <img src={sensorValueIcon} alt="sensor-value" />
                                <div className="float-left">
                                    <h4>Sensor Value</h4>
                                    <p>
                                        E.g. “When sensor value rises above
                                        30°C”
                                    </p>
                                </div>
                                <i className="material-icons right">
                                    keyboard_arrow_right
                                </i>
                            </div>
                            <div
                                className="modal-option"
                                onClick={showGatewaySelection}
                                onKeyDown={showGatewaySelection}
                            >
                                <img
                                    src={gatewayStatusIcon}
                                    alt="gateway-status"
                                />
                                <div className="float-left">
                                    <h4>Gateway Status</h4>
                                    <p>E.g. “When gateway comes online”</p>
                                </div>
                                <i className="material-icons right">
                                    keyboard_arrow_right
                                </i>
                            </div>
                            <div
                                className="modal-option"
                                onClick={proceedToRecurrencePage}
                                onKeyDown={proceedToRecurrencePage}
                            >
                                <img src={recurrenceIcon} alt="recurrence" />
                                <div className="float-left">
                                    <h4>Recurrence</h4>
                                    <p>E.g. “Every Sunday and Monday”</p>
                                </div>
                                <i className="material-icons right">
                                    keyboard_arrow_right
                                </i>
                            </div>
                            <div
                                className="modal-option"
                                onClick={proceedToOnDatePage}
                                onKeyDown={proceedToOnDatePage}
                            >
                                <img
                                    className="float-left mr-3"
                                    src={dateIcon}
                                    alt="date"
                                />
                                <div className="float-left">
                                    <h4>On a Date</h4>
                                    <p>E.g. “On 1st of January”</p>
                                </div>
                                <i className="material-icons right">
                                    keyboard_arrow_right
                                </i>
                            </div>

                            <div
                                className="modal-option"
                                onClick={() => {
                                    setGoToActionDetail(false);
                                    handleConditionsClose();
                                    setIsShowEventVariables(true);
                                }}
                                onKeyDown={() => {
                                    setGoToActionDetail(false);
                                    handleConditionsClose();
                                    setIsShowEventVariables(true);
                                }}
                            >
                                <img
                                    className="float-left mr-3"
                                    src={evaluateIcon}
                                    alt="evaluate"
                                />
                                <div className="float-left">
                                    <h4>Evaluate Event Variable</h4>
                                    <p>
                                        E.g. “When Event Variable value less
                                        than 5”
                                    </p>
                                </div>
                                <i className="material-icons right">
                                    keyboard_arrow_right
                                </i>
                            </div>
                        </div>
                    </Form>
                </Modal.Body>
            </Modal>
            {/* Select Action Modal */}
            <Modal
                show={selectAction}
                onHide={handleActionsClose}
                animation={false}
                centered
            >
                <Modal.Header>
                    <Modal.Title>Add Action</Modal.Title>
                    <Button
                        variant=""
                        className="close-button"
                        onClick={handleActionsClose}
                    >
                        <span className="material-icons">close</span>
                    </Button>
                </Modal.Header>

                <Modal.Body>
                    <Form className="condition-options-list">
                        <div className="scroll-list float-left">
                            <div
                                className={`modal-option ${
                                    IS_BASIC_PLAN ? "disabled" : ""
                                }`}
                                onClick={() => {
                                    if (IS_BASIC_PLAN) return;
                                    showAction(ACTION_EMAIL);
                                }}
                                onKeyDown={() => {
                                    if (IS_BASIC_PLAN) return;
                                    showAction(ACTION_EMAIL);
                                }}
                            >
                                <img src={ActionEmail} alt="action-email" />
                                <div className="float-left">
                                    <h4>Send Email</h4>
                                    <p>
                                        Send email to one or more email
                                        addresses
                                    </p>
                                </div>
                                <i className="material-icons right">
                                    keyboard_arrow_right
                                </i>
                            </div>
                            <div
                                className={`modal-option ${
                                    IS_BASIC_PLAN ? "disabled" : ""
                                }`}
                                onClick={() => {
                                    if (IS_BASIC_PLAN) return;
                                    showAction(ACTION_SMS);
                                }}
                                onKeyDown={() => {
                                    if (IS_BASIC_PLAN) return;
                                    showAction(ACTION_SMS);
                                }}
                            >
                                <img src={ActionSMS} alt="action-sms" />
                                <div className="float-left">
                                    <h4>Send SMS</h4>
                                    <p>Send SMS to one or more phone numbers</p>
                                </div>
                                <i className="material-icons right">
                                    keyboard_arrow_right
                                </i>
                            </div>
                            <div
                                className="modal-option"
                                onClick={() => {
                                    showAction(ACTION_NOTIF);
                                }}
                                onKeyDown={() => {
                                    showAction(ACTION_NOTIF);
                                }}
                            >
                                <img
                                    src={ActionNotification}
                                    alt="action-notification"
                                />
                                <div className="float-left">
                                    <h4>Send Push Notification</h4>
                                    <p>
                                        Send notification to one or more users
                                    </p>
                                </div>
                                <i className="material-icons right">
                                    keyboard_arrow_right
                                </i>
                            </div>
                            <div
                                className="modal-option"
                                onClick={showActuatorSelection}
                                onKeyDown={showActuatorSelection}
                            >
                                <img
                                    src={ActionActuator}
                                    alt="action-actuator"
                                />
                                <div className="float-left">
                                    <h4>Trigger Actuator</h4>
                                    <p>Add an action to trigger Actuator</p>
                                </div>
                                <i className="material-icons right">
                                    keyboard_arrow_right
                                </i>
                            </div>
                            <div
                                className="modal-option"
                                onClick={showDelayModal}
                                onKeyDown={showDelayModal}
                            >
                                <img src={DelayIcon} alt="delay event" />
                                <div className="float-left">
                                    <h4>Add Delay</h4>
                                    <p>
                                        Add a delay before an action gets
                                        triggered
                                    </p>
                                </div>
                                <i className="material-icons right">
                                    keyboard_arrow_right
                                </i>
                            </div>

                            <div
                                className="modal-option"
                                onClick={() => {
                                    handleActionsClose();
                                    setGoToActionDetail(true);
                                    setIsShowEventVariables(true);
                                }}
                                onKeyDown={() => {
                                    handleActionsClose();
                                    setGoToActionDetail(true);
                                    setIsShowEventVariables(true);
                                }}
                            >
                                <img
                                    className="float-left mr-3"
                                    src={evaluateIconBackdrop}
                                    alt="evaluate"
                                />
                                <div className="float-left">
                                    <h4>Modify Event Variable</h4>
                                    <p>Modify the value of Event variable</p>
                                </div>
                                <i className="material-icons right">
                                    keyboard_arrow_right
                                </i>
                            </div>
                        </div>
                    </Form>
                </Modal.Body>
            </Modal>

            <SelectEventVariableModal
                isShowEventVariables={isShowEventVariables}
                setIsShowEventVariables={setIsShowEventVariables}
                eventVariableSelected={eventVariableSelected}
                eventVariables={eventVariables}
                handleSelectedEventVariable={handleSelectEventVariable}
                setEventVariableSelected={setEventVariableSelected}
                modalTitle="Select Event Variable"
            />

            {/* Select Gateway Modal */}
            {[CONDITION_GATEWAY_STATUS].indexOf(selectedCondition) >= 0 && (
                <Modal
                    show={selectGateway}
                    onHide={closeGatewaySelection}
                    animation={false}
                    centered
                >
                    <Modal.Header>
                        <Modal.Title>Select Gateway</Modal.Title>
                        <Button
                            variant=""
                            className="close-button"
                            onClick={closeGatewaySelection}
                        >
                            <span className="material-icons">close</span>
                        </Button>
                    </Modal.Header>
                    <Modal.Body>
                        <Form className="floar-left">
                            <FormControl
                                type="text"
                                placeholder="Search.."
                                className="mb-4"
                                onChange={(e: any) => {
                                    searchGateways(e.target.value);
                                }}
                            ></FormControl>
                            <div className="scroll-multiple-list float-left">
                                {renderGateways()}
                            </div>
                        </Form>
                    </Modal.Body>
                    <Modal.Footer>
                        {radioBtnSelected ? (
                            <Button
                                variant="primary"
                                onClick={() => showCondition()}
                            >
                                {selectedCondition === CONDITION_GATEWAY_STATUS
                                    ? "DONE"
                                    : "NEXT"}
                            </Button>
                        ) : (
                            ""
                        )}
                    </Modal.Footer>
                </Modal>
            )}
            {/* Select LDSU Modal */}
            {selectModalVisible &&
                [CONDITION_LDSU_STATUS].indexOf(selectedCondition) >= 0 && (
                    <LDSUSelectModal
                        {...{
                            unitType,
                            isVisible: selectModalVisible,
                            onClose: () => {
                                setSelectModalVisible(false);
                            },
                            onFinish: (device: any) => {
                                if (unitType === LDSUTypeDict.LDSU.label) {
                                    showCondition(undefined, {
                                        selectedSensorDetails: {
                                            ...selectedSensorDetails,
                                            name: device.name,
                                            ldsuUUID: device.ldsu_uuid,
                                            gatewayId: device.gatewayId,
                                            gatewayName: device.gatewayName,
                                            bus: device.bus,
                                        },
                                    });
                                }
                            },
                        }}
                    />
                )}
            {/* Select device Modal */}
            {((selectModalVisible &&
                [ACTION_ACTUATOR].indexOf(unitType) >= 0) ||
                [CONDITION_SENSOR_VALUE, CONDITION_SENSOR_STATUS].indexOf(
                    selectedCondition
                ) >= 0) && (
                <SensorActuatorSelectModal
                    {...{
                        unitType,
                        isVisible: selectModalVisible,
                        onClose: () => {
                            setSelectModalVisible(false);
                        },
                        onFinish: (device: any) => {
                            switch (unitType) {
                                case DeviceTypeDict.sensor.label:
                                    showCondition(undefined, {
                                        selectedSensorDetails: {
                                            ...selectedSensorDetails,
                                            name: device.sensor_name,
                                            bus: device.bus,
                                            ldsuUUID: device.ldsu_uuid,
                                            said: device.SAID,
                                            gatewayId: device.gatewayId,
                                            type: device.sensor_type,
                                            gatewayName: device.gatewayName,
                                            unit: device.unit,
                                            min: device.min,
                                            max: device.max,
                                        },
                                    });
                                    break;

                                case DeviceTypeDict.actuator.label:
                                    showAction(ACTION_ACTUATOR, {
                                        selectedActuatorDetails: {
                                            name: device.sensor_name,
                                            ldsuUUID: device.ldsu_uuid,
                                            said: device.SAID,
                                            gatewayId: device.gatewayId,
                                            type: device.sensor_type,
                                            obj: device.OBJ,
                                            appId: device.APPID,
                                            // TODO: update actuator status/ config when using new event service
                                            // config_mode,
                                            // actionMode
                                        },
                                    });
                                    break;

                                default:
                                    break;
                            }
                        },
                    }}
                />
            )}
            {/* Set delay modal */}
            <SetDelayModal
                delay={editDelayObj.delay}
                isOpen={selectModalVisible && unitType === "delay"}
                onClose={() => {
                    setSelectModalVisible(false);
                    setUnitType("");
                    setEditDelayObj({ delay: defaultDelayValue });
                    setWarningPosition(null);
                }}
                onError={(error) => {
                    setModalShow(true);
                    setModalType("err");
                    setModalContent(error);
                    setWarningPosition(null);
                }}
                onSave={handleEditDelayAction}
                warningPosition={warningPosition}
            />

            <DefaultModal
                modalShow={modalShow}
                setModalShow={setModalShow}
                modalType={modalType}
                modalContent={modalContent}
                okAction={() => {
                    if (toDelete.type === EVENT) {
                        history.push(`/events`);
                    } else {
                        setModalShow(false);
                    }
                }}
                deleteFunction={() => {
                    if (toDelete.type === CONDITION) {
                        deleteCondition();
                    } else if (toDelete.type === ACTION) {
                        deleteAction();
                    } else if (toDelete.type === EVENT) {
                        deleteEvent();
                    }
                }}
            />

            <DefaultModal
                modalShow={isShowDeleteModal}
                setModalShow={setIsShowDeleteModal}
                modalType={"dlt"}
                modalContent={"Do you want to delete this Event variable?"}
                deleteFunction={() => {
                    setIsShowDeleteModal(false);
                }}
            />

            <DefaultModal
                modalShow={showGuardWarning}
                setModalShow={setShowGuardWarning}
                modalType={"custom"}
                modalTitle="Error Details"
                modalButton={
                    <Button
                        variant="primary"
                        onClick={() => {
                            setShowGuardWarning(false);
                        }}
                    >
                        OK
                    </Button>
                }
                modalContent={
                    "It must be guarded by adding an additional AND condition using a non-event variable or a non-time range condition to avoid triggering the event repeatedly."
                }
            />
        </ContentWrapper>
    );
};

export default EventDetails;
